import { FeatureFlag } from 'constants-flags';

import useFlag from './useFlag';

export function useReservableTeamRulesFixEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.ReservableTeamRulesFix, false);

  return Boolean(isEnabled);
}
